/**
 * Constants definition.
 *
 * @type {{PENDING: string, REJECTED: string, ACCEPTED: string}}
 */
const PARTNERSHIP_REQUEST = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PARTNERSHIP_REQUEST_ENUM = Object.keys(PARTNERSHIP_REQUEST);

const PENDING = PARTNERSHIP_REQUEST_ENUM[0];
const REJECTED = PARTNERSHIP_REQUEST_ENUM[1];
const ACCEPTED = PARTNERSHIP_REQUEST_ENUM[2];

export {
  PARTNERSHIP_REQUEST,
  PARTNERSHIP_REQUEST_ENUM,
  PENDING,
  REJECTED,
  ACCEPTED,
};
